import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { authors: Array }

  add() {
    const newRow = document.createElement("div")
    newRow.className = "flex gap-2"
    newRow.innerHTML = `
      <select name="author_ids[]" class="form-select flex-1">
        <option value="">Select an author...</option>
        ${this.authorsValue.map(a => `<option value="${a.id}">${a.name}</option>`).join("")}
      </select>
      <button type="button" data-action="author-select#remove" class="btn-outline text-red-600">Remove</button>
    `
    this.containerTarget.appendChild(newRow)
  }

  remove(event) {
    const row = event.target.closest(".flex")
    if (this.containerTarget.children.length > 1) {
      row.remove()
    } else {
      row.querySelector("select").value = ""
    }
  }
}
